import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AppProviders } from './app/AppProviders';
import { installRandomUuidFallback } from './shared/utils/randomUuid';
import './styles/tokens.css';
import './styles/global.css';
import './styles/components.css';

installRandomUuidFallback();

const root = document.getElementById('root');
if (!root) throw new Error('缺少应用根节点#root。');

createRoot(root).render(<StrictMode><AppProviders /></StrictMode>);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((error) => {
      console.warn('PWA应用壳注册失败', error);
    });
  });
}
